import { get } from 'svelte/store';
import { PLAYBACK, PLAYBACK_NAME } from '../../../shared/const';
import { globalStore } from './stores';
export const playbackSetup = () => {
    const { payload: { playback_id }, isPreview } = get(globalStore);
    const def = {
        videoCtrlOver: false,
        useOverlay: true,
        class: '',
    };
    let settings = {};
    if (playback_id === PLAYBACK.CTV) {
        settings = ctvSettings(def);
    }
    if (playback_id === PLAYBACK.LITE) {
        settings = liteSettings(def);
    }
    if (playback_id === PLAYBACK.MAX || playback_id === PLAYBACK.MAX_O3) {
        settings = maxSettings(def);
    }
    if (playback_id === PLAYBACK.SHOP) {
        settings = shopSettings(def);
    }
    if (playback_id === PLAYBACK.SOCIAL) {
        settings = socialSettings(def);
    }
    if (playback_id === PLAYBACK.TIKTOK) {
        settings = tiktokSettings(def, isPreview);
    }
    return settings;
};
function ctvSettings(settings) {
    const data = Object.assign({}, settings);
    data.class = 'playback-' + PLAYBACK_NAME[PLAYBACK.CTV];
    data.videoCtrlOver = true;
    data.useOverlay = false;
    return data;
}
function socialSettings(settings) {
    const data = Object.assign({}, settings);
    data.class = 'playback-' + PLAYBACK_NAME[PLAYBACK.SOCIAL];
    data.videoCtrlOver = true;
    return data;
}
function maxSettings(settings) {
    const data = Object.assign({}, settings);
    data.class = 'playback-' + PLAYBACK_NAME[PLAYBACK.MAX];
    return data;
}
function liteSettings(settings) {
    const data = Object.assign({}, settings);
    data.class = 'playback-' + PLAYBACK_NAME[PLAYBACK.LITE];
    return data;
}
function shopSettings(settings) {
    const data = Object.assign({}, settings);
    data.class = 'playback-' + PLAYBACK_NAME[PLAYBACK.SHOP];
    return data;
}
function tiktokSettings(settings, isPreview) {
    const data = Object.assign({}, settings);
    data.class = 'playback-' + PLAYBACK_NAME[PLAYBACK.TIKTOK];
    data.videoCtrlOver = true;
    data.useOverlay = !isPreview;
    return data;
}
